import React from 'react';
import { motion } from 'framer-motion';

// styles
import styles from "./index.module.scss";
import classNames from "classnames/bind";
const cn = classNames.bind(styles);

const Hero = () => {
  return (
    <div className={cn("wrapper")}>
      <div className={cn("container")}>
        <div className={cn("content")}>
          <div className={cn("image-container")}>
            <motion.div
              className={cn("image")}
              initial={{ opacity: 1, scale: 1 }}
              animate={{ opacity: 1, scale: 1.05 }}
              transition={{ duration: 1, ease: "easeInOut" }}
            />
          </div>
          <motion.div
            className={cn("title")} z
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: "easeInOut", delay: 0.5 }}
          >
            <h1>Fondato nel 2009 dall’Avv. Enrico Bevilacqua, lo Studio ha sede a Pordenone e opera nelle principali aree del Diritto Civile, Commerciale e Societario, nonché del Diritto Penale, della Crisi d’impresa e delle procedure concorsuali, sia in ambito giudiziale che stragiudiziale, offrendo ai propri clienti un’assistenza tempestiva, professionale e di qualità.</h1>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;